import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  label: {
    color: theme.palette.common.gray800,
    fontSize: '0.875rem',
    marginLeft: theme.spacing(1),
  },
  labelRoot: {
    margin: 0,
  },
  switchBase: {
    '&.Mui-checked': {
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
      color: theme.palette.common.white,
      transform: 'translateX(12px)',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
    color: theme.palette.common.white,
    padding: theme.spacing(0.25),
  },
  switchChecked: {
    transform: 'translateX(18px)',
  },
  switchRoot: {
    display: 'flex',
    height: theme.spacing(2),
    padding: 0,
    width: theme.spacing(3.5),
  },
  switchThumb: {
    boxShadow: 'none',
    height: theme.spacing(1.5),
    width: theme.spacing(1.5),
  },
  switchTrack: {
    backgroundColor: theme.palette.common.gray400,
    borderRadius: theme.spacing(1),
    opacity: 1,
  },
}));

export default useStyles;
